module.exports = __webpack_public_path__ + "static/media/IconGavelOrange.e4e80e47.svg";